import React from 'react';
import { Document } from '../types/documents';
import { DocumentRow } from './DocumentRow';
interface DocumentListProps {
  documents: Document[];
  onViewDocument: (doc: Document) => void;
}
export function DocumentList({
  documents,
  onViewDocument
}: DocumentListProps) {
  return <div className="flex flex-col w-full max-h-[400px] overflow-y-auto custom-scrollbar" data-id="element-3">
      {documents.map(doc => <DocumentRow key={doc.id} document={doc} onView={onViewDocument} data-id="element-4" />)}
    </div>;
}